import getApiHttpClient from '../../../httpClients/getApiHttpClient';
import type {
  GoogleStartResponse,
  GoogleStatusResponse,
  GranolaStatusResponse,
  OAuthStartResponse,
  SlackStatusResponse,
  TokenStatusResponse,
} from './types';

export async function fetchClickupStatus(): Promise<TokenStatusResponse> {
  const res = await getApiHttpClient().get<TokenStatusResponse>('/api/v1/cfo/integrations/clickup');
  return res.data;
}

export async function saveClickupToken(token: string): Promise<TokenStatusResponse> {
  const res = await getApiHttpClient().put<TokenStatusResponse>(
    '/api/v1/cfo/integrations/clickup',
    { token },
  );
  return res.data;
}

export async function removeClickupToken(): Promise<TokenStatusResponse> {
  const res = await getApiHttpClient().delete<TokenStatusResponse>(
    '/api/v1/cfo/integrations/clickup',
  );
  return res.data;
}

export async function fetchGranolaStatus(): Promise<GranolaStatusResponse> {
  const res = await getApiHttpClient().get<GranolaStatusResponse>(
    '/api/v1/cfo/integrations/granola',
  );
  return res.data;
}

export async function saveGranolaKey(token: string): Promise<GranolaStatusResponse> {
  const res = await getApiHttpClient().put<GranolaStatusResponse>(
    '/api/v1/cfo/integrations/granola',
    { token },
  );
  return res.data;
}

export async function removeGranolaKey(): Promise<GranolaStatusResponse> {
  const res = await getApiHttpClient().delete<GranolaStatusResponse>(
    '/api/v1/cfo/integrations/granola',
  );
  return res.data;
}

export async function fetchGoogleStatus(): Promise<GoogleStatusResponse> {
  const res = await getApiHttpClient().get<GoogleStatusResponse>('/api/v1/cfo/integrations/google');
  return res.data;
}

export async function fetchGoogleStartUrl(): Promise<GoogleStartResponse> {
  const res = await getApiHttpClient().get<GoogleStartResponse>(
    '/api/v1/cfo/integrations/google/start?returnTo=settings',
  );
  return res.data;
}

export async function disconnectGoogle(): Promise<void> {
  await getApiHttpClient().delete('/api/v1/cfo/integrations/google');
}

export async function fetchSlackStatus(): Promise<SlackStatusResponse> {
  const res = await getApiHttpClient().get<SlackStatusResponse>('/api/v1/cfo/integrations/slack');
  return res.data;
}

export async function fetchSlackStartUrl(): Promise<OAuthStartResponse> {
  const res = await getApiHttpClient().get<OAuthStartResponse>(
    '/api/v1/cfo/integrations/slack/start?returnTo=settings',
  );
  return res.data;
}

export async function disconnectSlack(): Promise<void> {
  await getApiHttpClient().delete('/api/v1/cfo/integrations/slack');
}
